//   
// AGNES - Technical Support Web
//   
// TechnicalSupportPendingController.js
//   
// Copyright (c) 2015 Toyota Central Europe - Czech s.r.o.
//   
// Permission is hereby granted, free of charge, to any person
// obtaining a copy of this software and associated documentation
// files (the "Software"), to deal in the Software without
// restriction, including without limitation the rights to use,
// copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the
// Software is furnished to do so, subject to the following
// conditions:
//   
// The above copyright notice and this permission notice shall be
// included in all copies or substantial portions of the Software.
//   
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
// EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES
// OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
// NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
// HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
// WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
// FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
// OTHER DEALINGS IN THE SOFTWARE.
// 

angular.module("Agnes")
    .controller("TechnicalSupportPendingController", [
        "$scope", "$sessionStorage", "$http", "$activity", "$notification", "$oidc",
        function ($scope, $sessionStorage, $http, $activity, $notification, oidc) {

            // Storage
            $scope.$storage = $sessionStorage.$default({
                technicalSupportPending: {
                    orderName: "CreateDate",
                    orderDesc: true,
                    refreshTime: "900000"
                }
            });

            // Refresh time
            $scope.$watch("$storage.technicalSupportPending.refreshTime", function (newValue, oldValue) {
                if (!angular.isUndefinedNullOrEmpty($scope.$storage.repairer) && $scope.$storage.repairer.id !== -1 && newValue !== oldValue) {
                    $scope.refresh();
                }
            });

            // Repairer
            $scope.$watch("$storage.repairer", function (newValue, oldValue) {
                if (!angular.isUndefinedNullOrEmpty(newValue) && newValue.id !== -1 && newValue.id !== oldValue.id) {
                    $scope.refresh();
                }
            });

            // Pending
            $scope.sorting = function (orderName) {
                if ($scope.$storage.technicalSupportPending.orderName === orderName) {
                    $scope.$storage.technicalSupportPending.orderDesc = !$scope.$storage.technicalSupportPending.orderDesc;
                } else {
                    $scope.$storage.technicalSupportPending.orderName = orderName;
                    $scope.$storage.technicalSupportPending.orderDesc = false;
                }
            };

            $scope.sortingClass = function (orderName) {
                if ($scope.$storage.technicalSupportPending.orderName === orderName) {
                    if ($scope.$storage.technicalSupportPending.orderDesc) {
                        return "fa fa-caret-down";
                    } else {
                        return "fa fa-caret-up";
                    }
                } else {
                    return "";
                }
            };

            $scope.refresh = function () {
                clearTimeout($scope.refreshTimer);

                $activity.start();
                $http
                    .get("/api/technical-support/pending/" + $scope.$storage.repairer.id, {
                        headers: {
                            Authorization: oidc.current.token_type + " " + oidc.current.access_token
                        }
                    })
                    .then(function (response) {
                        $scope.list = response.data;
                    }, function (response) {
                        $notification.addError(response.status, response);
                    }).then(function () {
                        $activity.finish();
                        $scope.refreshTimer = setTimeout($scope.refresh, $scope.$storage.technicalSupportPending.refreshTime);
                    });
            };

            // On Load
            if (!angular.isUndefinedNullOrEmpty($scope.$storage.repairer) && $scope.$storage.repairer.id !== -1) {
                $scope.refresh();
            }

            // On destroy
            $scope.$on('$locationChangeStart', function (event) {
                clearTimeout($scope.refreshTimer);
            });
        }
    ]);